module.exports = __webpack_public_path__ + "static/mickael-tournier-262768-unsplash-544badc67a30c381ca2a250079933b38.jpg";